import { render } from "./dealerInquiry.vue?vue&type=template&id=9b9f53c2&scoped=true"
import script from "./dealerInquiry.vue?vue&type=script&lang=js"
export * from "./dealerInquiry.vue?vue&type=script&lang=js"

import "./dealerInquiry.vue?vue&type=style&index=0&id=9b9f53c2&lang=scss&scoped=true"

import exportComponent from "/Users/jinjing/Desktop/jj/code1/HM0518/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b9f53c2"]])

export default __exports__